import { type components, TableTypeEnum } from "@selector/shared/openapi";
import type { GridApi } from "ag-grid-community";
import { createContext, type Dispatch, type RefObject, type SetStateAction } from "react";

import type { ColumnRow } from "../ColumnSelectionGrid.tsx";
import type { TreeColumnType } from "../ColumnSelectionPopover.tsx";

export interface ColumnTemplatesState {
  columnsRows: ColumnRow[] | null;
  gridApi: RefObject<GridApi<ColumnRow> | null>;
  setGridApi: (api: GridApi<ColumnRow>) => void;
  tableSpecForTemplates: Partial<components["schemas"]["TableRequest"]>;
  currentColumnSelection: string[];
  setColumnSelection: Dispatch<SetStateAction<ColumnTemplatesState["currentColumnSelection"]>>;
  setTemplateColumns: Dispatch<SetStateAction<TreeColumnType[] | null>>;
}

export const ColumnTemplatesContext = createContext<ColumnTemplatesState>({
  columnsRows: null,
  gridApi: { current: null },
  setGridApi: () => {},
  tableSpecForTemplates: { resultType: TableTypeEnum.ORGANISM },
  currentColumnSelection: [],
  setColumnSelection: () => {},
  setTemplateColumns: () => {},
});
